var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      ref: "contextmenu",
      staticClass: "custom-point-menu",
      style: { left: _vm.left + "px", top: _vm.top + "px" },
      attrs: { id: "custom-contextmenu", tabindex: "1" },
    },
    [
      _c(
        "ul",
        _vm._l(_vm.menuItem, function (item) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(
                    !!item.disabledFunc && item.disabledFunc(_vm.dataSet)
                  ),
                  expression:
                    "!(!!item.disabledFunc && item.disabledFunc(dataSet))",
                },
              ],
              key: item.name,
              staticClass: "cus-menu-item",
              on: {
                click: function ($event) {
                  return _vm.handleCommand(item)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "top-btn-box" }, [
        _c("i", {
          staticClass: "el-icon-close top-btn-item",
          on: { click: _vm.close },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }